import * as clipboard from "clipboard-polyfill";
import Alerts from "./Alerts";

/**
 * Взаимодействие с буфером обмена
 */
export default {
    mixins: [Alerts],
    methods: {
        /**
         * Копирование в буфер обмена
         * @param {string} data
         */
        copyToClipboard: function (data) {
            clipboard
                .writeText(data)
                .then(() => this.alertInfo(this.$t('lang.main.success.clipboard')))
                .catch(error => {
                    this.alertError(this.$t('lang.main.error.clipboard'));
                    console.log(error);
                });
        }
    },
}
